import React from 'react'

import { SectionItem } from '../Section'
import { ContactInfo } from './../../ContactInfo'

export interface ContactInfoProps {
  vm?: ContactInfo
}

export function ContactInfoSectionItems({ vm }: ContactInfoProps) {
  return (
    <>
      <SectionItem label="Phone number" value={vm?.phoneNumber} isSensitive />
      <SectionItem label="Email address" value={vm?.email} isSensitive />
    </>
  )
}
